export enum ElementType {
	NODE = 'NODE',
	ELEMENT = 'ELEMENT',
	SUBELEMENT = 'SUBELEMENT',
}
